export default __webpack_public_path__ + "static/media/artist-default-avatar.af30330b.png";